"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var FormItem_1 = require("../FormItem");
var FormText = function (props) {
    var name = props.name, formatter = props.formatter, formTextProps = __rest(props, ["name", "formatter"]);
    return (react_1.default.createElement(formik_1.Field, { name: name }, function (_a) {
        var value = _a.field.value;
        var val = value ? value.toString() : '';
        var formattedVal = val;
        if (formatter)
            try {
                formattedVal = formatter(val);
            }
            catch (_b) {
                formattedVal = val;
            }
        return (react_1.default.createElement("span", __assign({ className: "ant-app-form-text" }, formTextProps), formattedVal));
    }));
};
exports.default = FormItem_1.withFormItem(FormText);
